import 'owl.carousel'
import ListingsCarousel from 'listings/scripts/carousel'
import ListingPrice from 'listings/scripts/listing_price'

class BlogPostListings {
  static async init () {
    return new BlogPostListings()
  }

  constructor () {
    this.rendered = false
    this.isLoading = false

    const renderedBlogPostListings = $('.rendered-blog-post-listings')
    this.blogPostListingsElement = document.getElementById('js-blog-post-listings')

    if (renderedBlogPostListings.length === 0 && this.blogPostListingsElement) {
      this.startObserving()
    }
  }

  startObserving () {
    if (!('IntersectionObserver' in window) ||
        !('IntersectionObserverEntry' in window) ||
        !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
      this.loadListings()
    } else {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          if (!this.rendered) {
            this.loadListings()
          }
        }
      })

      observer.observe(this.blogPostListingsElement)
    }
  }

  loadListings () {
    if (this.rendered) return
    if (this.isLoading) return

    this.isLoading = true

    $.ajax({
      url: location.pathname + '/listings',
      dataType: 'json'
    }).done((data) => {
      let element = $('#js-blog-post-listings')
      element.removeAttr('align')
      element.html(data.html)

      ListingsCarousel.init('#js-blog-post-listings .listings-carousel')
      ListingPrice.init()
      window.lazyLoadInstance.update()

      this.isLoading = false
      this.rendered = true
    }).fail((error) => console.log(error))
  }
}

export default BlogPostListings
